import React, { useEffect, useState } from "react";
import { Card, Typography, Descriptions, Spin, Row, Col } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";

const { Title, Paragraph } = Typography;

const TestimonialDetails = () => {
  const { id } = useParams();
  const [testimonial, setTestimonial] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonial();
  }, [id]);

  const fetchTestimonial = async () => {
    try {
      const response = await axios.get(`http://93.127.203.113:5005/testimonials/${id}`);
      setTestimonial(response.data);
    } catch (error) {
      console.error("Error fetching testimonial:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Card
          style={{
            width: "80%",
            maxWidth: "900px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Row gutter={[24, 24]} align="middle">
            {/* Left Column - Image */}
            <Col xs={24} md={8} style={{ textAlign: "center" }}>
              {testimonial.image ? (
                <img
                  src={`http://93.127.203.113:5005${testimonial.image}`}
                  alt="User"
                  style={{
                    width: "100%",
                    maxWidth: "180px",
                    borderRadius: "10px",
                    border: "3px solid #0c8c49",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "180px",
                    height: "180px",
                    borderRadius: "10px",
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#999",
                    border: "2px dashed #ccc",
                  }}
                >
                  No Image
                </div>
              )}
            </Col>

            {/* Right Column - Details */}
            <Col xs={24} md={16}>
              <Title level={3} style={{ color: "#0c8c49", marginBottom: "10px" }}>
                {testimonial.name}
              </Title>
              <Paragraph type="secondary" style={{ fontSize: "16px", marginBottom: "15px" }}>
                <strong>Company:</strong> {testimonial.company}
              </Paragraph>
              <Card
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "15px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                }}
              >
                <Paragraph
                  style={{
                    fontSize: "16px",
                    fontStyle: "italic",
                    color: "#555",
                    lineHeight: "1.5",
                  }}
                >
                  "{testimonial.message}"
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default TestimonialDetails;
